//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formBox from './formBox.vue';
import Table from './table.vue';
export default {
  components: {
    formBox: formBox,
    Table: Table
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {}
};